var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"name":'go-to-' + _vm.targetStep},on:{"click":function($event){return _vm.switchStep()}}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.targetStep)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }